import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_WORK_CATEGORIES].GET_REPORTS_FINANCE_BY_WORK_CATEGORIES]: {
    url: '/company/:companyId/reports/finance/by_work_categories/',
  },
}